var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"tw-cursor-pointer hover:tw-underline",class:_vm.classes,attrs:{"target":_vm.target},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }